// // src/app/modules/AccessControl/pages/components/ValidationModal.jsx
// import React from 'react';
// import { Modal } from 'react-bootstrap';
// import Moment from 'moment';
// import {
//   X, CheckCircle, XCircle, User, Phone, Mail, FileText,
//   Shield, Key, AlertTriangle, ChevronRight,
// } from 'lucide-react';
// import './ValidationModal.scss';

// export const ValidationModal = ({ show, onHide, validationResult, onCheckIn, loading }) => {
//   const [showRiskFactors, setShowRiskFactors] = React.useState(false);

//   if (!validationResult) return null;

//   const { valid, access_code, visitor, remaining_uses, error, security_check } = validationResult;
//   const isSuccess = valid && access_code;

//   const riskScore   = security_check?.risk_score   || access_code?.metadata?.risk_score   || 0;
//   const riskLevel   = security_check?.risk_level   || access_code?.metadata?.risk_level   || 'low';
//   const isHighRisk  = security_check?.is_high_risk || false;
//   const riskFactors = security_check?.risk_factors || [];

//   const getRiskVariant = () => {
//     if (riskScore < 30) return 'success';
//     if (riskScore < 50) return 'info';
//     if (riskScore < 70) return 'warning';
//     return 'danger';
//   };

//   const getRiskDescription = () => {
//     if (riskScore === 0)  return 'No security assessment performed';
//     if (riskScore < 30)   return 'No security concerns detected';
//     if (riskScore < 50)   return 'Standard verification recommended';
//     if (riskScore < 70)   return 'Additional verification advised';
//     return 'Exercise caution and verify identity';
//   };

//   return (
//     <Modal
//       show={show}
//       onHide={onHide}
//       centered
//       size="md"
//       className="validation-modal"
//     >
//       <div className="validation-modal-content">

//         {/* ── Header ─────────────────────────────────────────────────────── */}
//         <div className="modal-header-custom">
//           <div className="header-left">
//             <div className={`header-icon header-icon--${isSuccess ? 'success' : 'danger'}`}>
//               {isSuccess
//                 ? <CheckCircle size={16} />
//                 : <XCircle size={16} />}
//             </div>
//             <div className="header-text">
//               <h3>{isSuccess ? 'Access Validation' : 'Access Denied'}</h3>
//               <p>{isSuccess ? 'Valid code confirmed' : 'Code rejected'}</p>
//             </div>
//           </div>
//           <div className="header-right">
//             <button className="icon-btn" onClick={onHide}>
//               <X size={15} />
//             </button>
//           </div>
//         </div>

//         {/* ── Body ───────────────────────────────────────────────────────── */}
//         <div className="modal-body-custom">

//           {!isSuccess ? (
//             /* ── Denied ── */
//             <div className="vm-denied">
//               <div className="vm-denied__icon">
//                 <XCircle size={28} />
//               </div>
//               <div className="vm-denied__title">Access Denied</div>
//               <p className="vm-denied__msg">
//                 {error || 'Invalid or expired access code'}
//               </p>
//             </div>
//           ) : (
//             <>
//               {/* ── Status Banner ── */}
//               <div className="vm-status-banner vm-status-banner--success">
//                 <div className="vm-status-icon vm-status-icon--success">
//                   <CheckCircle size={20} />
//                 </div>
//                 <div className="vm-status-text">
//                   <strong>Access Granted</strong>
//                   <span>Identity verified — entry authorised</span>
//                 </div>
//               </div>

//               {/* ── High-Risk Warning ── */}
//               {isHighRisk && (
//                 <div className="vm-high-risk">
//                   <AlertTriangle size={16} />
//                   <div>
//                     <strong>High-Risk Visitor Detected</strong>
//                     <p>Security team has been notified. Please verify visitor identity before allowing entry.</p>
//                   </div>
//                 </div>
//               )}

//               {/* ── Visitor Info ── */}
//               <div className="vm-section">
//                 <div className="vm-section__title">Visitor Information</div>
//                 <div className="vm-rows">
//                   {visitor?.name && (
//                     <div className="vm-row">
//                       <span className="vm-row__label"><User size={13} />Name</span>
//                       <span className="vm-row__value">{visitor.name}</span>
//                     </div>
//                   )}
//                   {visitor?.phone && (
//                     <div className="vm-row">
//                       <span className="vm-row__label"><Phone size={13} />Phone</span>
//                       <span className="vm-row__value">{visitor.phone}</span>
//                     </div>
//                   )}
//                   {visitor?.email && (
//                     <div className="vm-row">
//                       <span className="vm-row__label"><Mail size={13} />Email</span>
//                       <span className="vm-row__value">{visitor.email}</span>
//                     </div>
//                   )}
//                   {access_code?.purpose && (
//                     <div className="vm-row">
//                       <span className="vm-row__label"><FileText size={13} />Purpose</span>
//                       <span className="vm-row__value">{access_code.purpose}</span>
//                     </div>
//                   )}
//                   {access_code?.here_to_see && (
//                     <div className="vm-row">
//                       <span className="vm-row__label"><User size={13} />Here to see</span>
//                       <span className="vm-row__value">{access_code.here_to_see}</span>
//                     </div>
//                   )}
//                 </div>
//               </div>

//               {/* ── Security Assessment ── */}
//               <div className="vm-section">
//                 <div className="vm-section__title">Security Assessment</div>

//                 <div className="vm-risk">
//                   <div className="vm-risk__score">
//                     <span className="num">{riskScore}</span>
//                     <span className="max">/100</span>
//                   </div>
//                   <div className="vm-risk__info">
//                     <span className={`risk-badge risk-badge--${getRiskVariant()}`}>
//                       <Shield size={11} />
//                       {riskLevel.toUpperCase()} RISK
//                     </span>
//                     <p className="vm-risk__desc">{getRiskDescription()}</p>
//                   </div>
//                 </div>

//                 {/* Risk Factors */}
//                 {riskFactors.length > 0 && (
//                   <div className="vm-risk-factors">
//                     <button
//                       className={`vm-risk-factors__toggle ${showRiskFactors ? 'open' : ''}`}
//                       onClick={() => setShowRiskFactors(v => !v)}
//                     >
//                       <ChevronRight size={13} />
//                       {showRiskFactors ? 'Hide' : 'View'} risk factors ({riskFactors.length})
//                     </button>

//                     {showRiskFactors && (
//                       <div className="vm-risk-factors__list">
//                         {riskFactors.map((factor, i) => (
//                           <div key={i} className="vm-risk-factor">
//                             <div className="vm-risk-factor__header">
//                               <AlertTriangle size={14} />
//                               <span className="title">
//                                 {factor.factor || factor.description || 'Security concern detected'}
//                               </span>
//                               {factor.severity && (
//                                 <span className={`factor-severity ${factor.severity}`}>
//                                   {factor.severity}
//                                 </span>
//                               )}
//                             </div>
//                             {factor.details && (
//                               <p className="vm-risk-factor__details">{factor.details}</p>
//                             )}
//                             {factor.contribution && (
//                               <span className="vm-risk-factor__contribution">
//                                 +{factor.contribution} pts
//                               </span>
//                             )}
//                           </div>
//                         ))}
//                       </div>
//                     )}
//                   </div>
//                 )}
//               </div>

//               {/* ── Access Details ── */}
//               <div className="vm-section">
//                 <div className="vm-section__title">Access Details</div>
//                 <div className="vm-rows">
//                   <div className="vm-row">
//                     <span className="vm-row__label"><Key size={13} />Code</span>
//                     <span className="vm-row__value">
//                       <span className="vm-code-pill">{access_code.code}</span>
//                     </span>
//                   </div>
//                 </div>
//               </div>
//             </>
//           )}
//         </div>

//         {/* ── Footer ─────────────────────────────────────────────────────── */}
//         <div className="modal-footer-custom">
//           {isSuccess ? (
//             <button className="sety-btn sety-btn-ghost" onClick={onHide} disabled={loading}>
//               Close
//             </button>
//           ) : (
//             <button className="btn btn-primary btn-sm" onClick={onHide}>
//               Dismiss
//             </button>
//           )}
//         </div>

//       </div>
//     </Modal>
//   );
// };


// src/app/modules/AccessControl/pages/components/ValidationModal.jsx
import React from 'react';
import { Modal } from 'react-bootstrap';
import Moment from 'moment';
import {
  X, CheckCircle, XCircle, User, Phone, Mail, FileText,
  Shield, Key, AlertTriangle, ChevronRight, Clock, MapPin,
  Briefcase, Home, BadgeCheck, Zap, Building2,
} from 'lucide-react';
import './ValidationModal.scss';

// ─── Shared primitives ────────────────────────────────────────────────────────

function SectionTitle({ children }) {
  return <div className="vm-section__title">{children}</div>;
}

function VmRows({ children }) {
  return <div className="vm-rows">{children}</div>;
}

function VmRow({ label, icon: Icon, value, children }) {
  return (
    <div className="vm-row">
      <span className="vm-row__label">
        {Icon && <Icon size={13} />}
        {label}
      </span>
      <span className="vm-row__value">{children ?? value ?? '—'}</span>
    </div>
  );
}

function InlineBadge({ color, bg, label, icon: Icon }) {
  return (
    <span className="vm-inline-badge" style={{ background: bg, color }}>
      {Icon && <Icon size={10} />}
      {label}
    </span>
  );
}

// ─── Type-specific body sections ─────────────────────────────────────────────

function VisitorBody({ result }) {
  const [showRiskFactors, setShowRiskFactors] = React.useState(false);
  const { access_code, person, visitor, security_check, remaining_uses } = result;

  // Support both old (visitor) and new (person) shape
  const v = person || visitor || {};

  const security    = security_check || {};
  const riskScore   = security.risk_score   ?? access_code?.metadata?.risk_score   ?? 0;
  const riskLevel   = security.risk_level   ?? access_code?.metadata?.risk_level   ?? 'low';
  const isHighRisk  = security.is_high_risk ?? false;
  const riskFactors = security.risk_factors ?? [];

  const getRiskVariant = () => {
    if (riskScore < 30) return 'success';
    if (riskScore < 50) return 'info';
    if (riskScore < 70) return 'warning';
    return 'danger';
  };

  const getRiskDescription = () => {
    if (riskScore === 0) return 'No security assessment performed';
    if (riskScore < 30)  return 'No security concerns detected';
    if (riskScore < 50)  return 'Standard verification recommended';
    if (riskScore < 70)  return 'Additional verification advised';
    return 'Exercise caution and verify identity';
  };

  return (
    <>
      {isHighRisk && (
        <div className="vm-high-risk">
          <AlertTriangle size={16} />
          <div>
            <strong>High-Risk Visitor Detected</strong>
            <p>Security team has been notified. Please verify visitor identity before allowing entry.</p>
          </div>
        </div>
      )}

      {/* Session */}
      <div className="vm-section">
        <SectionTitle>Session Authorization</SectionTitle>
        <VmRows>
          {remaining_uses != null && (
            <VmRow icon={Key} label="Remaining entries" value={remaining_uses} />
          )}
          {access_code?.valid_until && (
            <VmRow icon={Clock} label="Valid until" value={Moment(access_code.valid_until).format('h:mm A, MMM D')} />
          )}
          {access_code?.purpose && (
            <VmRow icon={FileText} label="Purpose" value={access_code.purpose} />
          )}
          {access_code?.here_to_see && (
            <VmRow icon={User} label="Here to see" value={access_code.here_to_see} />
          )}
          {access_code?.space_name && (
            <VmRow icon={MapPin} label="Location" value={access_code.space_name} />
          )}
          <VmRow icon={Shield} label="Risk level">
            <InlineBadge
              color={['#16a34a','#2563EB','#D97706','#DC2626'][['success','info','warning','danger'].indexOf(getRiskVariant())]}
              bg={['#F0FDF4','#EFF6FF','#FFFBEB','#FEF2F2'][['success','info','warning','danger'].indexOf(getRiskVariant())]}
              label={`${riskLevel.toUpperCase()} · ${riskScore}`}
              icon={Shield}
            />
          </VmRow>
        </VmRows>
      </div>

      {/* Contact */}
      {(v.phone || v.email) && (
        <div className="vm-section">
          <SectionTitle>Contact</SectionTitle>
          <VmRows>
            {v.phone && <VmRow icon={Phone} label="Phone" value={v.phone} />}
            {v.email && <VmRow icon={Mail}  label="Email" value={v.email} />}
          </VmRows>
        </div>
      )}

      {/* Risk factors */}
      {riskFactors.length > 0 && (
        <div className="vm-section">
          <SectionTitle>Security Alerts</SectionTitle>
          <div className="vm-risk-factors">
            <button
              className={`vm-risk-factors__toggle ${showRiskFactors ? 'open' : ''}`}
              onClick={() => setShowRiskFactors(v => !v)}
            >
              <ChevronRight size={13} />
              {showRiskFactors ? 'Hide' : 'View'} risk factors ({riskFactors.length})
            </button>

            {showRiskFactors && (
              <div className="vm-risk-factors__list">
                {riskFactors.map((factor, i) => (
                  <div key={i} className="vm-risk-factor">
                    <div className="vm-risk-factor__header">
                      <AlertTriangle size={14} />
                      <span className="title">
                        {factor.factor || factor.description || 'Security concern detected'}
                      </span>
                      {factor.severity && (
                        <span className={`factor-severity ${factor.severity}`}>{factor.severity}</span>
                      )}
                    </div>
                    {factor.details && (
                      <p className="vm-risk-factor__details">{factor.details}</p>
                    )}
                    {factor.contribution && (
                      <span className="vm-risk-factor__contribution">+{factor.contribution} pts</span>
                    )}
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
}

function StaffBody({ result }) {
  const { access_code, person, shift } = result;

  const statusColor = () => {
    if (shift?.shift_status === 'on_time') return '#16a34a';
    if (shift?.shift_status === 'early')   return '#2563EB';
    return '#D97706';
  };
  const statusBg = () => {
    if (shift?.shift_status === 'on_time') return '#F0FDF4';
    if (shift?.shift_status === 'early')   return '#EFF6FF';
    return '#FFFBEB';
  };
  const statusLabel = () => {
    if (shift?.shift_status === 'on_time') return 'On Time';
    if (shift?.shift_status === 'early')   return `${shift.minutes_early}m Early`;
    return `${shift?.minutes_late}m Late`;
  };

  const shiftNumber  = shift?.shift_number_today || shift?.metadata?.shift_number_today || 1;
  const shiftOrdinal = shiftNumber === 1 ? '1st' : shiftNumber === 2 ? '2nd' : `${shiftNumber}th`;

  const isLate  = shift?.shift_status === 'late';
  const isEarly = shift?.shift_status === 'early';

  return (
    <>
      {isLate && (
        <div className="vm-high-risk">
          <Clock size={16} />
          <div>
            <strong>{shift.minutes_late} minute{shift.minutes_late > 1 ? 's' : ''} late</strong>
            <p>Manager has been notified of this late arrival.</p>
          </div>
        </div>
      )}

      {isEarly && (
        <div className="vm-high-risk vm-high-risk--info">
          <Zap size={16} />
          <div>
            <strong>{shift.minutes_early} minute{shift.minutes_early > 1 ? 's' : ''} early</strong>
            <p>Ahead of schedule — shift starts {Moment(shift.scheduled_start || shift.scheduled_shift_start).format('h:mm A')}.</p>
          </div>
        </div>
      )}

      {/* Shift details */}
      <div className="vm-section">
        <SectionTitle>Shift Details</SectionTitle>
        <VmRows>
          <VmRow icon={BadgeCheck} label="Shift today" value={`${shiftOrdinal} shift`} />
          <VmRow icon={Clock} label="Arrival status">
            <InlineBadge color={statusColor()} bg={statusBg()} label={statusLabel()} />
          </VmRow>
          {(shift?.scheduled_start || shift?.scheduled_shift_start) && (
            <VmRow icon={Clock} label="Scheduled start"
              value={Moment(shift.scheduled_start || shift.scheduled_shift_start).format('h:mm A')} />
          )}
          {(shift?.actual_start || shift?.actual_shift_start) && (
            <VmRow icon={Clock} label="Checked in at"
              value={Moment(shift.actual_start || shift.actual_shift_start).format('h:mm A')} />
          )}
          {(shift?.scheduled_end || shift?.scheduled_shift_end) && (
            <VmRow icon={Clock} label="Scheduled end"
              value={Moment(shift.scheduled_end || shift.scheduled_shift_end).format('h:mm A')} />
          )}
        </VmRows>
      </div>

      {/* Identity */}
      <div className="vm-section">
        <SectionTitle>Identity</SectionTitle>
        <VmRows>
          {person?.employee_id && <VmRow icon={Key}       label="Employee ID" value={person.employee_id} />}
          {person?.staff_role  && <VmRow icon={Briefcase} label="Role"        value={person.staff_role}  />}
          {person?.space_name  && <VmRow icon={MapPin}    label="Station"     value={person.space_name}  />}
          {!person?.employee_id && !person?.staff_role && !person?.space_name && (
            <VmRow icon={User} label="Type" value="Staff Member" />
          )}
        </VmRows>
      </div>
    </>
  );
}

function ResidentBody({ result }) {
  const { access_code, person, access_log } = result;

  return (
    <>
      {/* Residence */}
      <div className="vm-section">
        <SectionTitle>Residence</SectionTitle>
        <VmRows>
          {person?.unit_number && <VmRow icon={Home}     label="Unit"             value={person.unit_number} />}
          {person?.space_name  && <VmRow icon={Building2} label="Building / Block" value={person.space_name}  />}
          {access_log?.access_method && (
            <VmRow icon={Key} label="Access method"
              value={access_log.access_method.replace(/_/g, ' ')} />
          )}
          {access_log?.vehicle_plate && (
            <VmRow icon={Key} label="Vehicle plate" value={access_log.vehicle_plate} />
          )}
          {!person?.unit_number && !access_log?.vehicle_plate && (
            <VmRow icon={Home} label="Type" value="Permanent Resident" />
          )}
        </VmRows>
      </div>

      {/* Contact */}
      {(person?.phone || person?.email) && (
        <div className="vm-section">
          <SectionTitle>Contact</SectionTitle>
          <VmRows>
            {person.phone && <VmRow icon={Phone} label="Phone" value={person.phone} />}
            {person.email && <VmRow icon={Mail}  label="Email" value={person.email} />}
          </VmRows>
        </div>
      )}

      {/* Access pass */}
      <div className="vm-section">
        <SectionTitle>Access Pass</SectionTitle>
        <VmRows>
          <VmRow icon={Shield} label="Pass type">
            <InlineBadge color="#7C3AED" bg="#F5F3FF" label="Permanent" icon={Shield} />
          </VmRow>
          <VmRow icon={Clock} label="Valid until"
            value={
              access_code?.valid_until
                ? Moment(access_code.valid_until).year() > 2090
                  ? 'No expiry'
                  : Moment(access_code.valid_until).format('MMM D, YYYY')
                : 'No expiry'
            }
          />
        </VmRows>
      </div>
    </>
  );
}

// ─── Main modal ──────────────────────────────────────────────────────────────

export const ValidationModal = ({ show, onHide, validationResult, onCheckIn, loading }) => {
  if (!validationResult) return null;

  const checkInType = validationResult.check_in_type || 'visitor';
  const isSuccess   = validationResult.valid && (validationResult.access_code || validationResult.access_log);
  const error       = validationResult.error;

  // Normalise person — works for both old visitor shape and new unified shape
  const person = validationResult.person || {
    name:    validationResult.visitor?.name,
    phone:   validationResult.visitor?.phone,
    email:   validationResult.visitor?.email,
    company: validationResult.visitor?.company,
  };

  const typeConfig = {
    visitor:  { label: 'Visitor',  iconEl: <User size={14} />,       headerClass: 'header-icon--visitor'  },
    staff:    { label: 'Staff',    iconEl: <BadgeCheck size={14} />, headerClass: 'header-icon--staff'    },
    resident: { label: 'Resident', iconEl: <Home size={14} />,       headerClass: 'header-icon--resident' },
  };
  const cfg = typeConfig[checkInType] || typeConfig.visitor;

  return (
    <Modal show={show} onHide={onHide} centered size="md" className="validation-modal">
      <div className="validation-modal-content">

        {/* ── Header ── */}
        <div className="modal-header-custom">
          <div className="header-left">
            <div className={`header-icon ${isSuccess ? 'header-icon--success' : 'header-icon--danger'}`}>
              {isSuccess ? <CheckCircle size={16} /> : <XCircle size={16} />}
            </div>
            <div className="header-text">
              <h3>{isSuccess ? 'Identity Verified' : 'Entry Unauthorized'}</h3>
              <p>{isSuccess ? `${cfg.label} · access granted` : 'Credential mismatch or expiration'}</p>
            </div>
          </div>
          <div className="header-right">
            {/* Type chip */}
            <div className={`header-type-chip header-type-chip--${checkInType}`}>
              {cfg.iconEl}
              {cfg.label}
            </div>
            <button className="icon-btn" onClick={onHide}><X size={15} /></button>
          </div>
        </div>

        {/* ── Body ── */}
        <div className="modal-body-custom">
          {!isSuccess ? (
            <div className="vm-denied">
              <div className="vm-denied__icon"><XCircle size={28} /></div>
              <div className="vm-denied__title">Entry Unauthorized</div>
              <p className="vm-denied__msg">
                {error || 'Invalid or expired access code. Terminal locked for this subject.'}
              </p>
            </div>
          ) : (
            <>
              {/* Person header */}
              <div className="vm-person-header">
                <div className={`vm-person-avatar vm-person-avatar--${checkInType}`}>
                  {person?.name?.[0]?.toUpperCase() || '?'}
                </div>
                <div className="vm-person-info">
                  <div className="vm-person-name">{person?.name || 'Unknown'}</div>
                  {person?.email   && <div className="vm-person-sub">{person.email}</div>}
                  {person?.company && <div className="vm-person-sub">{person.company}</div>}
                </div>
                <div className="vm-person-time">
                  {Moment().format('h:mm A')}
                </div>
              </div>

              {/* Type-specific sections */}
              {checkInType === 'visitor'  && <VisitorBody  result={validationResult} />}
              {checkInType === 'staff'    && <StaffBody    result={validationResult} />}
              {checkInType === 'resident' && <ResidentBody result={validationResult} />}
            </>
          )}
        </div>

        {/* ── Footer ── */}
        <div className="modal-footer-custom">
          <button className="sety-btn sety-btn-ghost" onClick={onHide} disabled={loading}>
            {isSuccess ? 'Done' : 'Dismiss'}
          </button>
        </div>

      </div>
    </Modal>
  );
};